import {
  useEffect
} from "react";
import {
  useMobileAppLink
} from "../../utils/deeplink-utility";
import {
  useLocation
} from "react-router-dom";

export default function Apps() {
  const location = useLocation();
  // const pathname = location.pathname;
  const searchParams = new URLSearchParams(location.search);

  // Get the first part of the path (slug)
  // const slug = pathname.split("/")[1] || "";

  // Create the URL string
  const queryString = searchParams.toString();
  const url = `${queryString ? `?${queryString}` : ""}`;
  // console.log("🚀 ~ Apps ~ url:", url);

  const {
    openApp
  } = useMobileAppLink({
    packageName: `com.tanamemas.apps`,
    androidScheme: `tanamemas://tanamemas${url}`,
    iosScheme: `tanamemas://${url}`,
    webFallbackUrl: "https://tanamemas.id",
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      openApp();
    }, 1200);

    const redirectTimer = setTimeout(() => {
      window.location.href = "https://tanamemas.id";
    }, 5000);

    return () => {
      clearTimeout(timer);
      clearTimeout(redirectTimer);
    };
  }, [openApp]); // Added openApp to dependency array

  return null; // or you could return a loading spinner/component
}